import React from "react";
import { Helmet } from "react-helmet-async";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Carousel from "./components/Carousel";
import { Container } from "react-bootstrap";
import CardGroup from "./components/CardGroup";
import slides from "./data/slides.json";
import services from "./data/services.json";
import Section from "./components/Section";

const Home = () => {

  return (
    <React.Fragment>
      <Helmet>
        <title>Aspiricity - Aspire Higher</title>
      </Helmet>
      <Header>
        <Carousel slides={slides}/>
      </Header>
      <Section bgColor="bg-light" textColor="text-dark" title="Technology Services">
        <Container className="mb-4">
          <p className="lead">
            Aspiricity provides consulting, training, and modernization services focused on practical software delivery, quality engineering, and evolving technology solutions.
          </p>
        </Container>
        <CardGroup cards={services} />
        <br />
      </Section>
      <Footer/>
    </React.Fragment>
  );
};

export default Home;
